import { AxiosResponse } from "axios";
import { APIType, APIParams, Method } from "../../contexts/FetchContext";
import { Sandbox } from "../../models/sandbox";

export const sandboxAPI = (API: APIType, URL: string) => {
  const sandboxURL = URL + 'SandBox';

  const options = {
    getAll: async (params?: any) => {
      const APIParams: APIParams = {
        method: Method.get,
        needToken: true,
        URL: sandboxURL,
        param: params
      }
      return await API(APIParams)
      .then((response: AxiosResponse) => {
        return response.data as Sandbox[];
      }).catch((error) => {
        console.log(error);
        throw new Error(error);
      });
    },
    getById: async (id: number) => {
      const APIParams = {
        method: Method.get,
        needToken: true,
        URL: `${sandboxURL}/${id}`,
      }
      return await API(APIParams)
      .then((response: AxiosResponse) => {
        return response.data as Sandbox;
      }).catch((error) => {
        console.log(error);
        throw new Error(error);
      })
    },
    create: async (sandbox: Sandbox) => {
      const APIParams = {
        method: Method.post,
        needToken: true,
        URL: sandboxURL,
        body: JSON.stringify(sandbox)
      }
      return await API(APIParams)
      .then((response: AxiosResponse) => {
        return response.data as Sandbox;
      }).catch((error) => {
        console.log(error);
        throw new Error(error);
      })
    },
    update: async (sandbox: Sandbox) => {
      const APIParams = {
        method: Method.put,
        needToken: true,
        URL: sandboxURL,
        body: JSON.stringify(sandbox)
      }
      return await API(APIParams)
      .then((response: AxiosResponse) => {
        return response.data as Sandbox;
      }).catch((error) => {
        console.log(error);
        throw new Error(error);
      })
    }
  }
  return options;
}
